import { computed, ref } from 'vue'
import type { Errors } from '@/types/common'
import { toast } from 'vue3-toastify'
import type { AxiosError } from 'axios'

const errors = ref<Errors>({})

export function useErrorHandling() {
  const removeError = (key: string): void => {
    delete errors.value[key]
  }

  const clearAllErrors = (): void => {
    errors.value = {}
  }

  const setError = (key: string, value: string): void => {
    errors.value[key] = [value]
  }

  const hasErrors = computed(() => Object.keys(errors.value).length > 0)

  const handleApiError = (error: unknown) => {
    if ((error as AxiosError).isAxiosError) {
      const axiosError = error as AxiosError<{ errors: Errors; message: string }>

      if (axiosError.response) {
        const data = axiosError.response.data

        errors.value = data.errors ?? {}

        toast.error(data.message)
      }
    } else if (error instanceof Error) {
      toast.error(error.message)
    } else {
      console.error('Unknown error', error)
      toast.error({ title: 'An unexpected error occurred', color: 'error' })
    }
  }

  return {
    errors,
    removeError,
    handleApiError,
    setError,
    clearAllErrors,
    hasErrors,
  }
}
